/**
 * downloadPdfBytes — shared browser-download helper for produced PDF bytes.
 *
 * Extracted from `usePrintDialog` (was a private local helper) so the PLOT
 * single-sheet export AND the PDF-6.8 PUBLISH multi-page export reuse ONE
 * download path (no duplication). No-op outside a DOM environment (e.g. unit
 * tests of the calling hooks), so callers can run headless without guarding.
 */

/**
 * Trigger a browser download of the produced PDF bytes. No-op outside a DOM
 * environment (e.g. unit tests of the hook logic).
 */
export function downloadPdfBytes(bytes: Uint8Array, fileName: string): void {
  if (typeof document === "undefined" || typeof URL === "undefined") return;
  const blob = new Blob([bytes as BlobPart], { type: "application/pdf" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  // Revoke on the next tick so the click navigation has consumed the URL.
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
